var _classCallCheck = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

/**
 * Formula Error.
 */
var FormulaError = /*#__PURE__*/function () {
  "use strict";

  /**
   * @param {string} error - error code, i.e. #NUM!
   * @param {string} [msg] - detailed error message
   * @returns {FormulaError}
   */
  function FormulaError(error, msg) {
    _classCallCheck(this, FormulaError);

    if (msg == null && FormulaError.errorMap.has(error)) return FormulaError.errorMap.get(error);else if (msg == null) {
      this._error = error;
      FormulaError.errorMap.set(error, this);
    } else {
      this._error = error;
      this._msg = msg;
    }
  }
  /**
   * Get the error message.
   * @returns {*}
   */


  _createClass(FormulaError, [{
    key: "equals",

    /**
     * Return true if two errors are same.
     * @param {FormulaError} err
     * @returns {boolean} if two errors are same.
     */
    value: function equals(err) {
      return err instanceof FormulaError && err._error === this._error;
    }
    /**
     * Return the formula error in string representation.
     * @returns {string} the formula error in string representation.
     */

  }, {
    key: "toString",
    value: function toString() {
      return this._error;
    }
  }, {
    key: "message",
    get: function get() {
      return this._msg;
    }
    /**
     * Set the error message.
     * @param {string} msg
     */
    ,
    set: function set(msg) {
      this._msg = msg;
    }
    /**
     * Get the error.
     * @returns {string} formula error
     */

  }, {
    key: "error",
    get: function get() {
      return this._error;
    }
  }]);

  return FormulaError;
}();

FormulaError.errorMap = new Map();
/**
 * DIV0 error
 * @type {FormulaError}
 */

FormulaError.DIV0 = new FormulaError("#DIV/0!");
/**
 * NA error
 * @type {FormulaError}
 */

FormulaError.NA = new FormulaError("#N/A");
/**
 * NAME error
 * @type {FormulaError}
 */

FormulaError.NAME = new FormulaError("#NAME?");
/**
 * NULL error
 * @type {FormulaError}
 */

FormulaError.NULL = new FormulaError("#NULL!");
/**
 * NUM error
 * @type {FormulaError}
 */

FormulaError.NUM = new FormulaError("#NUM!");
/**
 * REF error
 * @type {FormulaError}
 */

FormulaError.REF = new FormulaError("#REF!");
/**
 * VALUE error
 * @type {FormulaError}
 */

FormulaError.VALUE = new FormulaError("#VALUE!");
/**
 * NOT_IMPLEMENTED error
 * @param {string} functionName - the name of the not implemented function
 * @returns {Error}
 * @constructor
 */

FormulaError.NOT_IMPLEMENTED = function (functionName) {
  return new Error("Function ".concat(functionName, " is not implemented."));
};
/**
 * TOO_MANY_ARGS error
 * @param functionName - the name of the errored function
 * @returns {Error}
 * @constructor
 */


FormulaError.TOO_MANY_ARGS = function (functionName) {
  return new Error("Function ".concat(functionName, " has too many arguments."));
};
/**
 * ARG_MISSING error
 * @param args - the name of the errored function
 * @returns {Error}
 * @constructor
 */


FormulaError.ARG_MISSING = function (args) {
  return new Error("Argument type ".concat(args.join(', '), " is missing."));
};

module.exports = FormulaError;